import React from 'react';
import { Card, Stack, Typography } from "@curves/ui-base";
import employeeInBodyInterviewMeasureItems from '@icoach/inbody/employeeInbodyInterview/EmployeeInBodyInterviewMeasureItems';
import { isEmpty } from '@util/utils';
import { MeasureCompareTable } from '@icoach/inbody/components';

const EmployeeInBodyInterviewMeasureCompareTable = ({ sourceData: validMeasureData }) => {
    return (
        <Card>
            {!isEmpty(validMeasureData) && validMeasureData.length > 1 ? (
                <Card.CardContent>
                    <MeasureCompareTable sourceData={validMeasureData} measureItems={employeeInBodyInterviewMeasureItems} />
                </Card.CardContent>
            ) : (
                <Card.CardContent className={'p-3'}>
                    <Stack justifyContent={'center'} alignItems={'center'}>
                        {isEmpty(validMeasureData) && (
                            <Typography variant="h6" className={'font-color-4'}>
                                無相關資料
                            </Typography>
                        )}
                        {validMeasureData.length === 1 && (
                            <Typography variant="h6" className={'font-color-4'}>
                                量身資料低於 2 筆無法進行比較
                            </Typography>
                        )}
                    </Stack>
                </Card.CardContent>
            )}
        </Card>
    );
};

export default EmployeeInBodyInterviewMeasureCompareTable;
